import { render, staticRenderFns } from "./tureyou.vue?vue&type=template&id=46046c40&"
import script from "./tureyou.vue?vue&type=script&lang=js&"
export * from "./tureyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports